export default "__VITE_ASSET__D3TIwOj6__"